import axios from "axios";
import Vue from "vue";
import router from "@/router";

Vue.prototype.$login_http = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_API_URL
});
Vue.prototype.$http = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_API_URL
});

Vue.prototype.$http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (
      404 === error.response.status &&
      error.response.data.error === "organization_not_found"
    ) {
      return Promise.resolve(
        router.push({
          path: "/404",
          query: { slug: error.response.data.extra_information }
        })
      );
    }
    if (401 === error.response.status) {
      localStorage.removeItem("authorized");
      router.push("/");
    } else {
      return Promise.reject(error);
    }
  }
);
